import { Award, BarChart3, FileSearch, Gavel, MousePointerClick, PenTool, Search, TrendingUp } from "lucide-react";
import { GetList } from "../../types/data-content";

export const getListManutencaoEvolucaoSites = () => {
  let list: GetList[] = [
    {
      productId: "#MES01",
      exibirFidelidade: false,
      image: "/assets/sites/manutencao-evolucao.jpg",
      titleCard: "Manutenção e Evolução de Sites",
      link: "/sites/manutencao-evolucao",
      price: "",
      priceSale: "",
      page: "/sites/manutencao-evolucao",
      filter: "sites",
      cardDescription: `
        Mantenha seu site sempre rápido, seguro, atualizado e preparado para gerar resultados.
      `,

      titlePage: "Manutenção e Evolução de Sites Profissionais",
      description: `
        Seu site precisa estar sempre atualizado, rápido e funcionando perfeitamente.
        A <strong>Sistemas Flex</strong> oferece um serviço completo de <strong>manutenção e evolução contínua</strong>,
        garantindo segurança, performance, melhorias visuais e atualizações constantes.
        
        Com nossa manutenção, seu site nunca fica desatualizado, ele evolui mês após mês.
      `,

      titleHowItWorks: "Como Funciona a Manutenção e Evolução?",
      steps: [
        {
          icon: Search,
          title: "Análise completa do site",
          description:
            "Identificamos problemas técnicos, oportunidades de melhoria, performance e segurança.",
        },
        {
          icon: Gavel,
          title: "Correções e atualizações",
          description:
            "Atualizamos plugins, temas, CMS, corrigimos erros e ajustamos funcionalidades.",
        },
        {
          icon: Award,
          title: "Otimizações de performance",
          description:
            "Deixamos o site mais rápido, leve e otimizado para mecanismos de busca (SEO).",
        },
        {
          icon: MousePointerClick,
          title: "Evolução contínua",
          description:
            "Adicionamos novas seções, melhoramos o design e ampliamos recursos sempre que necessário.",
        },
      ],

      processTitle:
        "Nossa Metodologia para Evoluir o Seu Site Mês Após Mês",
      processMarketing: [
        {
          icon: FileSearch,
          title: "Monitoramento e diagnóstico contínuo",
        },
        {
          icon: PenTool,
          title: "Melhorias visuais e novas seções",
        },
        {
          icon: TrendingUp,
          title: "Otimizações de SEO e velocidade",
        },
        {
          icon: BarChart3,
          title: "Relatórios mensais com o que foi feito",
        },
      ],

      conclusionPageMarketing: `
        Com a <strong>Manutenção e Evolução de Sites da Sistemas Flex</strong>,
        seu site nunca fica ultrapassado. Mantemos tudo atualizado, seguro,
        rápido e sempre melhorando.
        
        Você foca no seu negócio, nós cuidamos da sua presença digital.
        Uma manutenção profissional evita problemas, melhora resultados e dá mais
        credibilidade para sua marca.
      `,

      benefitsTitle: "Benefícios da Manutenção e Evolução",
      includedFeatures: [
        "Site sempre atualizado e seguro",
        "Maior performance e velocidade",
        "SEO em dia e melhores posições no Google",
        "Melhorias constantes no design",
        "Redução de erros e instabilidade",
        "Adições e ajustes sob demanda",
      ],
    },
  ];

  return list;
};
